import BaseResource from '@/lib/data/resource/BaseResource'

export default class CollarInputResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.lowStrike = payload.lowStrike ?? ''
    this.highStrike = payload.highStrike ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
